import { IParamsFiltrosQuery, IListaAsignaturas } from 'src/app/interfaces/ponderaciones';
import { IArchivoReporteCalificaciones, IListaReporteCalificacionesRes, IObtenerFiltros } from './../../interfaces/notas-parciales';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core'
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotasParcialesService {

  constructor(
    private http: HttpClient
  ) { }

  getHeaders(): HttpHeaders{
    return new HttpHeaders();
  }

  getListaIdDocentes(anyo: number, periodoId: number, asignaturaId: number, sedeId:number): Observable<any> {
    const url = `${environment.endpointAdministrativo}/v1/reporte-calificacion/obtener-docentes-filtros?anyo=${anyo}&periodo-id=${periodoId}&asignatura-id=${asignaturaId}&sede-id=${sedeId}`
    return this.http.get<any>(url, { headers: this.getHeaders() })
  } 

  listaReporteCalificaciones(body: any): Observable<any>{
    const url = `${environment.endpointAdministrativo}/v1/reporte-calificacion/buscaListadoReportes`;
    return this.http.post<any>(url, body, { headers: this.getHeaders() });
  }

  descargarArchivoCalificaciones(id:number): Observable<IArchivoReporteCalificaciones> {
    const url = `${environment.endpointAdministrativo}/v1/reporte-calificacion/obtener-reporte?idSolicitudReporte=${id}`;
    return this.http.get<IArchivoReporteCalificaciones>(url, { headers: this.getHeaders() });
  }

  generarReporte(body: any): Observable<any>{
    const url = `${environment.endpointAdministrativo}/v1/reporte-calificacion/generaSolicitudReporte`;
    return this.http.post<any>(url, body, { headers: this.getHeaders() });
  }

  buscarReporte(body: any): Observable<IListaReporteCalificacionesRes>{
    const url = `${environment.endpointAdministrativo}/v1/reporte-calificacion/buscaListadoReportes`;
    return this.http.post<IListaReporteCalificacionesRes>(url, body, { headers: this.getHeaders() });
  }

  getFiltros(periodoId:number, sedeId:number, docenteId:number): Observable<IObtenerFiltros>{
    const url = `${environment.endpointAdministrativo}/v1/reporte-calificacion/obtener-filtros?periodo-id=${periodoId}&sede-id=${sedeId}&docente-id=${docenteId}`;
    return this.http.get<IObtenerFiltros>(url, { headers: this.getHeaders() });
  }

  getFiltrosAsignaturas(filter: IParamsFiltrosQuery): Observable<IListaAsignaturas> {
    const url = `${environment.endpointAdministrativo}/v1/reporte-calificacion/buscar-asignatura?anyo=${filter.anyo}&periodo-id=${filter.periodoId}&sede-id=${filter.sedeId}`
    return this.http.get<IListaAsignaturas>(url, { headers: this.getHeaders() })
  }

  getFiltrosSedes(userId: number): Observable<any> {
    const url = `${environment.endpointAdministrativo}/v1/ponderacion/individual/obtener-sedes?usuario-id=${userId}`
    return this.http.get<any>(url, { headers: this.getHeaders() })
  }

  getReporte(reporteId: number): Observable<any> {
    const url = `${environment.endpointAdministrativo}/v1/reporte-calificacion/obtener-reporte-bytes?idSolicitudReporte=${reporteId}`;
    return this.http.get(url, {
      observe: 'response',
      headers: this.getHeaders(),
      responseType:'blob'
    })
  }
}
